import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import FormText from "react-bootstrap/FormText";
import Row from "react-bootstrap/Row";
import { Link, Redirect } from "react-router-dom";
import { BasicLoader } from "ui/loader";

class TokenLoginPage extends React.PureComponent {
  static get propTypes() {
    return {
      isAuthenticated: PropTypes.bool.isRequired,
      location: PropTypes.object.isRequired,
      onLogin: PropTypes.func.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      loginSuccess: false,
      submitted: false,
      token: "",
    };

    this.doLogin = this.doLogin.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.submit = this.submit.bind(this);
    this.updateToken = this.updateToken.bind(this);
  }

  doLogin() {
    const { onLogin } = this.props;
    const { token } = this.state;

    return onLogin(token)
      .then(() => {
        this.setState({ loginSuccess: true });
      })
      .finally(() => {
        this.setState({ submitted: false });
      });
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.submit();
    }
  }

  submit() {
    const { loginSuccess, submitted } = this.state;

    if (submitted || loginSuccess) {
      return;
    }

    this.setState({ submitted: true }, this.doLogin);
  }

  updateToken(e) {
    this.setState({ token: e.currentTarget.value });
  }

  render() {
    const { isAuthenticated, location, storesLoaded, title } = this.props;
    const { loginSuccess, submitted } = this.state;

    if (!storesLoaded) {
      return <BasicLoader />;
    }

    if (isAuthenticated) {
      const { state = {} } = location;
      const { nextLocation = {} } = state;

      if (nextLocation.pathname && nextLocation.pathname !== "/login") {
        return <Redirect to={nextLocation} />;
      }

      return <Redirect to="/" />;
    }

    return (
      <div className="login-page">
        <div className="header">
          <h1>{title}</h1>
        </div>
        <div className="login-box">
          <div className="login-box-body">
            <p className="login-box-msg">Sign in to start your session</p>
            <Form onKeyPress={this.handleKeyPress}>
              <FormGroup>
                <FormControl
                  type="input"
                  autoComplete="off"
                  disabled={loginSuccess}
                  id="tokenLogin"
                  onChange={this.updateToken}
                  placeholder="Login Token"
                />
                <FormText>Log in using an authentication token.</FormText>
              </FormGroup>
            </Form>
            <Row>
              <Col xs={{ span: 4, offset: 5 }}>
                <Link to="/">Return to Home</Link>
              </Col>
              <Col xs={3}>
                <Button
                  variant="primary"
                  className="btn-flat"
                  disabled={submitted || loginSuccess}
                  onClick={this.submit}
                >
                  Sign In
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export { TokenLoginPage };
